import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState, AppThunk } from "../../app/store"
import { ItemIds, Item } from "../../content/menu-items"




export interface CateringState {
  selectedItems: Item[],
  status: "idle" | "loading" | "failed"
}

const initialState: CateringState = {
  selectedItems: [],
  status: "idle",
  
}

// Application requirements do not currently require payment to be made from the application
// Should requirements change, implement the api call here.
// export const completePayment = createAsyncThunk(
//   "catering/completePayment",
//   async (amount: number) => {
//     const response = await completePayment(amount)
//     
//     return response.data
//   },
// )

export const cateringSlice = createSlice({
  name: "catering",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    addItem: (state, action: PayloadAction<Item>) => {
      state.selectedItems.push(action.payload)
    },
    removeItem: (state, action: PayloadAction<Item>) => {
      state.selectedItems = state.selectedItems.filter((item) => item.id !== action.payload.id)
    },
    clearCart: (state) => {
      state.selectedItems = []
    },
    
  },

// The `extraReducers` field lets the slice handle actions defined elsewhere,
// including actions generated by createAsyncThunk or in other slices.

// extraReducers: (builder) => {
//   builder
//     .addCase(completePayment.pending, (state) => {
//       state.status = "loading"
//     })
//     .addCase(completePayment.fulfilled, (state, action) => {
//       state.status = "idle"
//       state.value += action.payload
//     })
//     .addCase(completePayment.rejected, (state) => {
//       state.status = "failed"
//     })
//   }, 
})

export const { addItem, removeItem, clearCart } = cateringSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectedItems = (state: RootState) => state.catering.selectedItems



export default cateringSlice.reducer
